import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import client from "@/data/client";
import { enqueueSnackbar } from "notistack";
import { AxiosError } from "axios";
import { DefaultErrorResponse } from "@/types";

export function useCreateAgendaFeedbackMutation(callback?: () => void) {
  return useMutation(client.feedback.createAgendaFeedback, {
    onSuccess: (data) => {
      if (data.status) {
        enqueueSnackbar(`Feedback ${data.status} successfully`, {
          variant: "success",
        });
        if (callback) {
          callback();
        }
      } else {
        enqueueSnackbar("Something went wrong", {
          variant: "error",
        });
      }
    },
    onError: (error) => {
      const err = error as AxiosError<DefaultErrorResponse>;
      enqueueSnackbar(err.response?.data.message, {
        variant: "error",
      });
    },
  });
}

export function useCreateFeedbackRatingMutation(callback?: () => void) {
  const navigate = useNavigate();

  return useMutation(client.feedback.createFeedbackRating, {
    onSuccess: (data) => {
      if (data.token) {
        enqueueSnackbar(`Feedback saved successfully`, {
          variant: "success",
        });
        if (callback) {
          callback();
        } else {
          navigate(-1);
        }
      } else {
        enqueueSnackbar("Something went wrong", {
          variant: "error",
        });
      }
    },
    onError: (error) => {
      const err = error as AxiosError<DefaultErrorResponse>;
      enqueueSnackbar(err.response?.data.message, {
        variant: "error",
      });
    },
  });
}
